{
  "customFormsFeaturesData": {
    "titles": {
      "checkOut": "Salida",
      "checkInDeprecated": "Entrada (Obsoleto)",
      "checkIn": "Entrada",
      "receivedLoadInspection": "Inspección de Carga Recibida",
      "shippedLoadVerification": "Verificación de Carga Enviada",
      "appointmentsPerLoadType": "Citas por Tipo de Carga",
      "assetDetails": "Detalles del Activo",
      "yardManagementSystem": "Sistema de Gestión de Patio",
      "smartGateIntegration": "Integración con SmartGate",
      "idValidation": "Validación de ID",
      "gateManagement": "Gestión de Accesos",
      "appointmentCompleted": "Cita Completada"
    },
    "subtitles": {
      "phoneNumberAndCarrierCompanyWillBeCollectedByDefault": "<strong>Número de teléfono</strong> y <strong>empresa transportista</strong> se recopilarán por defecto"
    },
    "descriptions": {
      "captureCheckInDetailsFromDriversForBothPlannedAndUnplannedArrivals": "Captura detalles de entrada de los conductores para llegadas planificadas y no planificadas.",
      "captureCheckOutDataAfterAnAppointmentIsCompleted": "Captura datos de salida después de completar una cita.",
      "collectDriverInfoAsTheySelfCheckInForTheirPlannedAppointmentThisFeatureIsAnOptionalAddOnToOurGateManagementSolution": "Recoge información del conductor cuando se registre de forma autónoma para su cita planificada. Esta función es un complemento opcional de nuestra solución de Gestión de Accesos.",
      "documentDamageDiscrepanciesOrOtherIssuesRelatedToTheReceivedLoad": "Documenta daños, discrepancias u otros problemas relacionados con la carga recibida.",
      "documentLoadIntegrityAndOtherSecurityMeasuresRelatedToTheShippedLoad": "Documenta la integridad de la carga y otras medidas de seguridad relacionadas con la carga enviada.",
      "captureLoadTypeSpecificDetailsDuringAppointmentScheduling": "Captura detalles específicos del tipo de carga durante la programación de la cita.",
      "storeAndTrackDetailsOfTrailersAndContainersAsTheyArriveAtYourYard": "Almacena y rastrea detalles de remolques y contenedores a medida que llegan a tu patio.",
      "enableTheYmsModuleForThisWarehouseAlsoEnableTheAssetVisitFieldsForTheGateManagementApp": "Activa el módulo YMS para este almacén y también los campos de visita de activos en la aplicación de Gestión de Accesos.",
      "enableTheSmartGateModuleForThisWarehouse": "Activa el módulo SmartGate para este almacén.",
      "enableTheIdValidationForThisWarehouse": "Activa el módulo ID Validation para este almacén.",
      "enableTheGateManagementModuleForThisWarehouseWhichIncludesTheCheckIn": "Activa el módulo de Gestión de Accesos para este almacén, que incluye el registro de entrada.",
      "reviewAndManageAppointmentDataAfterCompletion": "Revisa y gestiona los datos de la cita después de su finalización."
    },
    "helpLinks": {
      "learnHowItWorksOrContactUsToRequestATrial": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">Conoce cómo funciona</a> o contáctanos para <a href=\"https://lp.opendock.com/gate-management\" target=\"_blank\">solicitar una prueba.</a>.",
      "learnHowItWorks": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">Conoce cómo funciona.</a>"
    },
    "enableDisclaimers": {
      "theDriversWillSeeThisFormWhenTheyAreCheckingThemselvesIn": "Los conductores verán este formulario cuando se registren ellos mismos.",
      "allFieldsOnThisFormWillBeAvailableAndVisibleDuringAppointmentScheduling": "Todos los campos de este formulario estarán <strong>disponibles y visibles</strong> durante la programación de citas."
    },
    "disableDisclaimers": {
      "theDriversWillNotSeeThisFormWhenTheyAreCheckingThemselvesIn": "Los conductores no verán este formulario cuando se registren ellos mismos.",
      "allFieldsOnThisFormWillBeUnavailableDuringAppointmentSchedulingYouCanReEnableThisFormAtAnyTime": "Todos los campos de este formulario estarán <strong>no disponibles</strong> durante la programación de citas.<br />Puedes volver a habilitar este formulario en cualquier momento."
    },
    "labels": {
      "updateClaimsSupport": "Actualizar soporte de reclamos",
      "selectAClaimsSupportToUpdate": "Selecciona un soporte de reclamos para actualizar",
      "damageType": "Tipo de daño",
      "damageDescription": "Descripción del daño",
      "damagePhotos": "Fotos del daño",
      "discrepancyType": "Tipo de discrepancia",
      "discrepancyDescription": "Descripción de la discrepancia",
      "discrepancyPhotos": "Fotos de la discrepancia",
      "loadSecurityChecked": "Seguridad de la carga verificada",
      "loadSecurityDescription": "Descripción de la seguridad de la carga",
      "loadIntegrityPhotos": "Fotos de integridad de la carga",
      "sealIntegrityPhotos": "Fotos de integridad de los sellos"
    }
  }
}
